'use strict';
import get from 'lodash/get';
import noop from 'lodash/noop';
import 'rxjs/add/observable/combineLatest';
import 'rxjs/add/observable/merge';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/map';
import {getAsset, getAssetProject, getOrganization, getProject, getProjectModel} from '../../app/model/reducers/state';
import {toStringStatic} from '../../assets/domain/AssetDomain';
import {SCOPE_DESTROY} from '../../config/constants/view-events';
import {
  supportsDownload,
  supportsImportExport,
} from '../../core-utilities-implementation/device-services/DeviceServicesCordova';
import {getAsString, getCollection, getId, getLink} from '../../core-utilities/domain/ReduxUtils';
import {eventToObservable} from '../../core-utilities/rx-utils';
import {createMilestoneRequestModal} from '../../milestones/redux/createMilestone';
import {updateMilestoneRequestModal} from '../../milestones/redux/updateMilestone';
import {MILESTONE_COLLECTION} from '../../projects/domain/config';
import {PLACEHOLDER_MILESTONE} from '../../projects/domain/MilestoneDomain';
import {deleteAssetProjectRequest} from '../../projects/redux/deleteAssetProject';
import {deleteProjectRequest} from '../../projects/redux/deleteProject';
import {updateProjectRequestModal} from '../../projects/redux/updateProject';
// import {createAssetTaskRequestModal} from '../redux/createAssetTask';
// import {createProjectTaskRequestModal} from '../redux/createProjectTask';
// import {createTemplateTaskRequestModal} from '../redux/createTemplateTask';
import {getTaskListActions} from '../actions';
import {ASSET_TASK_COLLECTION, TASK_COLLECTION} from '../domain/config';
import {TaskType} from '../enums/TaskType';


TasksListController.$inject = [
  '$scope',
  '$log',
  '$ngRedux',
  '$contextMenu',
  '$modal',
  '$toast',
  '$popup',
  '$permissions',
  'rxPermissionsService',
  'FilesDownloadService',
  'MilestoneDomain',
  'ctrlConfig',
  'taskCreateModals',
  'TOAST_TYPES',
  'timerExportService',
  'parentStatusService',
];

function get_VIEW_ACTIONS_PROJECT(roleData) {
  const isLocked = roleData.projectIsLocked;
  return {
    canAddTask: isLocked ? 'task_data_create_locked' : 'task_data_create',
    canAddMilestone: isLocked ? 'milestone_data_create_locked' : 'milestone_data_create',
    canDownloadFiles: 'task_fulfillments_view',
    canEdit: 'project_data_edit',
  };
}

function get_VIEW_ACTIONS_TEMPLATE(roleData) {
  const isLocked = roleData.projectIsLocked || roleData.assetProjectIsLocked;
  return {
    canAddTask: isLocked ? 'template_task_data_create_locked' : 'template_task_data_create',
    canAddMilestone: isLocked ? 'template_milestone_data_create_locked' : 'template_milestone_data_create',
  };
}

function get_VIEW_ACTIONS_ASSET(roleData) {
  const isLocked = roleData.projectIsLocked || roleData.assetProjectIsLocked;
  return {
    canAddTask: isLocked ? 'asset_task_data_create_locked' : 'asset_task_data_create',
    canDownloadFiles: 'asset_task_fulfillments_view',
  };
}

// TODO(tasks): Add method to re-sync the current asset project with the project task template, adding all missing tasks and requirements. This must optionally ignore or force requirements on completed tasks
export function TasksListController(
  $scope,
  $log,
  $ngRedux,
  $contextMenu,
  $modal,
  $toast,
  $popup,
  $permissions,
  rxPermissionsService,
  FilesDownloadService,
  MilestoneDomain,
  ctrlConfig,
  taskCreateModals,
  TOAST_TYPES,
  timerExportService,
  parentStatusService,
) {
  const vm = this;
  bindReactProps();

  function bindReactProps() {
    const permissions$ = observePermissions();
    const isTemplate = ctrlConfig.taskType === TaskType.TEMPLATE;
    const baseListProps = {
      onClickOptions: showMenu,
      onClickOptions_wrap: false,
      onTaskContextMenu: (e, model) => showTaskMenu(model),
      onTaskContextMenu_wrap: false,
      onClickOptionsButton: (e, model) => showMilestoneMenu(model),
      onClickOptionsButton_wrap: false,
      onAddTask: () => goToTasksCreate(null),
      onAddTask_wrap: false,
      onAddMilestone: () => goToMilestonesCreate(null),
      onAddMilestone_wrap: false,
      onMilestoneAddTask: (e, model) => goToTasksCreate(model),
      onMilestoneAddTask_wrap: false,
      onMilestoneDownloadAllFiles: isTemplate ? noop : (e, model) => downloadMilestoneFiles(model),
      onMilestoneDownloadAllFiles_wrap: false,
      canAddTask: false,
      canAddMilestone: false,
      canDownloadFiles: false,
      canEdit: false,
    };

    vm.listProps = baseListProps;

    permissions$
      .startWith({permissions: {}})
      .throttleTime(500, void 0, {leading: true, trailing: true})
      .takeUntil(eventToObservable($scope, SCOPE_DESTROY))
      .subscribe(permissionsData => $scope.$evalAsync(() => __update(permissionsData)));

    function __update(permissionsData) {
      vm.listProps = {
        ...baseListProps,
        canAddTask: get(permissionsData.permissions, 'canAddTask', false),
        canAddMilestone: get(permissionsData.permissions, 'canAddMilestone', false),
        canDownloadFiles: get(permissionsData.permissions, 'canDownloadFiles', false),
        canEdit: get(permissionsData.permissions, 'canEdit', false),
      };
    }
  }

  function observePermissions() {
    return rxPermissionsService.userProjectRoleData$
      .map(rxPermissionsService.projectStateFn(getVIEW_ACTIONS))
      .startWith({permissions: {}, hasPermission: noop});
  }

  /**
   * @param {RoleData} roleData
   * @return {Object}
   */
  function getVIEW_ACTIONS(roleData) {
    switch (ctrlConfig.taskType) {
      case TaskType.ASSET:
        return get_VIEW_ACTIONS_ASSET(roleData);

      case TaskType.PROJECT:
        return get_VIEW_ACTIONS_PROJECT(roleData);

      case TaskType.TEMPLATE:
        return get_VIEW_ACTIONS_TEMPLATE(roleData);
    }
  }

  /*****************************************************************************************************************
   * Context Menu Actions
   ****************************************************************************************************************/

  function generate_CREATE_MILESTONE(milestone) {
    let permission = ctrlConfig.taskType !== TaskType.PROJECT
      ? 'template_milestone_data_create'
      : 'milestone_data_create';
    if (parentStatusService.isProjectLocked())
      permission += '_locked';

    const msg = milestone ? 'milestones.context.edit.label' : 'tasks.context.milestones.create.label';
    return {
      permission,
      action: {messageId: msg, action: goToMilestonesCreate.bind(vm, milestone)},
    };
  }

  function generate_DELETE_MILESTONE(milestone) {
    let permission = ctrlConfig.taskType !== TaskType.PROJECT
      ? 'template_milestone_data_delete'
      : 'milestone_data_delete';
    if (parentStatusService.isProjectLocked())
      permission += '_locked';

    return {
      permission,
      action: {
        messageId: 'milestones.context.delete.label',
        action: deleteMilestone.bind(vm, milestone),
        important: true,
      },
    };
  }

  function generate_CREATE_TASK(milestone) {
    let permission = $permissions.permissionPrefix(ctrlConfig.taskType) + 'task_data_create';
    if (parentStatusService.isParentProjectLocked(ctrlConfig.taskType))
      permission += '_locked';

    return {
      permission,
      action: {messageId: 'tasks.context.tasks.create.label', action: goToTasksCreate.bind(vm, milestone)},
    };
  }

  function generate_DELETE_TASK(task) {
    let permission;
    switch (ctrlConfig.taskType) {
      case TaskType.ASSET:
        permission = 'asset_task_data_delete';
        break;

      case TaskType.PROJECT:
        permission = 'task_data_delete';
        break;

      case TaskType.TEMPLATE:
        permission = !task.isPrivate ? 'template_task_data_delete' : 'task_data_delete';
        break;
    }

    if (parentStatusService.isParentTaskLocked(ctrlConfig.taskType, task))
      permission += '_locked';

    return {
      permission: permission,
      action: {messageId: 'tasks.details.context.delete.label', action: deleteTask.bind(vm, task), important: true},
    };
  }

  function generate_DOWNLOAD_ALL_MILESTONE(milestone) {
    return {
      permission: $permissions.permissionPrefix(ctrlConfig.taskType) + 'task_fulfillments_view',
      action: {
        messageId: 'requirements.files.list.context.download.all.label',
        action: downloadMilestoneFiles.bind(null, milestone),
      },
    };
  }

  function generate_DOWNLOAD_ALL_TASK(task) {
    return {
      permission: $permissions.permissionPrefix(ctrlConfig.taskType) + 'task_fulfillments_view',
      action: {
        messageId: 'tasks.details.context.download.files.label',
        action: FilesDownloadService.downloadTaskFiles.bind(
          FilesDownloadService,
          getId(task),
          getAsString(task),
          ctrlConfig.taskType,
        ),
      },
    };
  }

  function generate_TASKS_IMPORT() {
    let permission = $permissions.getTasksPermission(ctrlConfig.taskType, 'tasks_import');
    if (parentStatusService.isParentProjectLocked(ctrlConfig.taskType))
      permission += '_locked';

    return {
      permission,
      action: {messageId: 'tasks.context.tasks.import.label', action: openTaskImport},
    };
  }

  const TASKS_EXPORT = {
    permission: $permissions.getTasksPermission(ctrlConfig.taskType, 'tasks_view'),
    action: {messageId: 'tasks.context.tasks.export.label', action: openTaskExport},
  };

  const DOWNLOAD_ALL = {
    permission: $permissions.permissionPrefix(ctrlConfig.taskType) + 'task_fulfillments_view',
    action: {messageId: 'requirements.files.list.context.download.all.label', action: downloadProjectFiles},
  };

  const EDIT_PROJECT = {
    permission: 'project_data_edit',
    action: {messageId: 'projects.home.context.edit.label', action: editProject},
  };

  function generate_DELETE_ASSET_PROJECT() {
    return {
      permission: parentStatusService.isAssetProjectLocked() ? 'project_assets_delete_locked' : 'project_assets_delete',
      action: {messageId: 'tasks.context.project.assets.remove.label', action: removeAssetFromProject, important: true},
    };
  }

  function generate_DELETE_PROJECT() {
    return {
      permission: parentStatusService.isProjectLocked() ? 'project_data_delete_locked' : 'project_data_delete',
      action: {messageId: 'projects.home.context.delete.label', action: deleteProject, important: true},
    };
  }

  function showMenu() {
    const rootState = $ngRedux.getState();
    const project = getProject(rootState);
    const assetProject = getAssetProject(rootState);
    const projectId = getId(project);
    const checkActions = [];

    if (projectId && (ctrlConfig.taskType !== TaskType.ASSET || assetProject)) {
      $contextMenu.addActionByProject(checkActions, projectId, generate_CREATE_MILESTONE(null));
      $contextMenu.addActionByProject(checkActions, projectId, generate_CREATE_TASK(null));

      if (supportsImportExport()) {
        $contextMenu.addActionByProject(checkActions, projectId, generate_TASKS_IMPORT());
        $contextMenu.addActionByProject(checkActions, projectId, TASKS_EXPORT);
      }

      if (supportsDownload() && (
        (ctrlConfig.taskType === TaskType.PROJECT && project)
        || (ctrlConfig.taskType === TaskType.ASSET && assetProject)
      )) {
        $contextMenu.addActionByProject(checkActions, projectId, DOWNLOAD_ALL);
      }

      if (ctrlConfig.taskType === TaskType.ASSET && assetProject) {
        const assetProjectId = getId(assetProject);
        timerExportService.buildContextAction(checkActions, () => {
          timerExportService.exportAssetProject(assetProjectId);
        });
      } else if (ctrlConfig.taskType === TaskType.PROJECT && project) {
        timerExportService.buildContextAction(checkActions, () => {
          timerExportService.exportProject();
        });
      }

      if (ctrlConfig.taskType === TaskType.PROJECT && project) {
        $contextMenu.addActionByProject(checkActions, projectId, EDIT_PROJECT);
      }

      if (ctrlConfig.taskType === TaskType.ASSET) {
        $contextMenu.addActionByProject(checkActions, projectId, generate_DELETE_ASSET_PROJECT());
      } else if (ctrlConfig.taskType === TaskType.PROJECT) {
        $contextMenu.addActionByProject(checkActions, projectId, generate_DELETE_PROJECT());
      }
    }

    $contextMenu.showByPermission({
      titleMessageId: 'tasks.context.title.label',
      cancelMessageId: 'defaults.context.cancel.label',
      actions: checkActions,
    });
  }

  function downloadMilestoneFiles(milestone) {
    const rootState = $ngRedux.getState();
    const project = getProject(rootState);
    if (!project) return;
    const asset = getAsset(rootState);
    const assetProject = getAssetProject(rootState);
    let projectId;
    if (ctrlConfig.taskType === TaskType.PROJECT) {
      projectId = getId(project);
    } else {
      if (!assetProject || !asset) return;
      projectId = getId(assetProject);
    }

    const milestoneId = getId(milestone) === PLACEHOLDER_MILESTONE.id ? null : getId(milestone);
    const milestoneName = getId(milestone) === PLACEHOLDER_MILESTONE.id ? 'Misc' : getAsString(milestone);

    FilesDownloadService.downloadMilestoneFiles(projectId, milestoneId, milestoneName, ctrlConfig.taskType);
  }

  function downloadProjectFiles() {
    const rootState = $ngRedux.getState();
    const project = getProject(rootState);
    const asset = getAsset(rootState);
    const assetProject = getAssetProject(rootState);
    if (!project) return;
    let projectId;
    let projectName = project.name;
    if (ctrlConfig.taskType === TaskType.PROJECT) {
      projectId = getId(project);
    } else {
      if (!assetProject || !asset) return;
      projectId = getId(assetProject);
      projectName += ' - ' + asset.name;
    }

    FilesDownloadService.downloadProjectFiles(projectId, projectName, ctrlConfig.taskType);
  }

  function showMilestoneMenu(milestone) {
    const rootState = $ngRedux.getState();
    const project = getProject(rootState);
    const projectId = project ? getId(project) : null;
    if (!projectId) return;
    const checkActions = [];
    const isPlaceholder = getId(milestone) === PLACEHOLDER_MILESTONE.id;

    if (isPlaceholder) {
      $contextMenu.addActionByProject(checkActions, projectId, generate_CREATE_TASK(null));
      $contextMenu.addActionByProject(checkActions, projectId, generate_DOWNLOAD_ALL_MILESTONE(milestone));

    } else {
      $contextMenu.addActionByProject(checkActions, projectId, generate_CREATE_MILESTONE(milestone));
      $contextMenu.addActionByProject(checkActions, projectId, generate_CREATE_TASK(milestone));

      if (ctrlConfig.taskType !== TaskType.TEMPLATE)
        $contextMenu.addActionByProject(checkActions, projectId, generate_DOWNLOAD_ALL_MILESTONE(milestone));

      if (ctrlConfig.taskType !== TaskType.ASSET)
        $contextMenu.addActionByProject(checkActions, projectId, generate_DELETE_MILESTONE(milestone));
    }

    return $contextMenu.showByPermission({
      titleMessageId: 'default.options.context.title.label',
      titleMessageParams: {name: isPlaceholder ? 'Misc' : milestone.name},
      cancelMessageId: 'defaults.context.cancel.label',
      actions: checkActions,
    });
  }

  function showTaskMenu(task) {
    if (!task) return;
    const taskId = getId(task);
    const checkActions = [];

    if (ctrlConfig.taskType === TaskType.ASSET) {
      if (supportsDownload())
        $contextMenu.addActionByAssetTask(checkActions, taskId, generate_DOWNLOAD_ALL_TASK(task));

      $contextMenu.addActionByAssetTask(checkActions, taskId, generate_DELETE_TASK(task));
    } else {
      if (supportsDownload() && ctrlConfig.taskType === TaskType.PROJECT)
        $contextMenu.addActionByTask(checkActions, taskId, generate_DOWNLOAD_ALL_TASK(task));

      // You may not delete a template task at the asset level
      if (getCollection(task) !== ASSET_TASK_COLLECTION || !getLink(task, 'task').id)
        $contextMenu.addActionByTask(checkActions, taskId, generate_DELETE_TASK(task));
    }

    $contextMenu.showByPermission({
      titleMessageId: 'default.options.context.title.label',
      titleMessageParams: {name: getAsString(task)},
      cancelMessageId: 'defaults.context.cancel.label',
      actions: checkActions,
    });
  }

  function goToTasksCreate(milestone) {
    return (!milestone || getId(milestone) === PLACEHOLDER_MILESTONE.id
      ? Promise.resolve(null)
      : MilestoneDomain.$get(getId(milestone)))
      .then(instance =>
        taskCreateModals.openCreateTask(
          instance,
          $scope,
          ctrlConfig.taskType,
        )
      );

    // const rootState = $ngRedux.getState();
    // const projectId = getId(getProject(rootState));
    // const assetProjectId = getId(getAssetProject(rootState));
    // const orgId = getId(getOrganization(rootState));
    // const model = {
    //   milestone: !milestone || getId(milestone) === PLACEHOLDER_MILESTONE.id ? null : milestone,
    // };
    //
    // if (!orgId || !projectId) {
    //   return;
    // } else if (ctrlConfig.taskType === TaskType.ASSET) {
    //   if (!assetProjectId)
    //     return;
    //
    //   $ngRedux.dispatch(createAssetTaskRequestModal.actions.showModal({
    //     assetProjectId,
    //     projectId,
    //     orgId,
    //     model,
    //   }));
    //
    // } else if (ctrlConfig.taskType === TaskType.PROJECT) {
    //   $ngRedux.dispatch(createProjectTaskRequestModal.actions.showModal({
    //     projectId,
    //     orgId,
    //     model,
    //   }));
    // } else if (ctrlConfig.taskType === TaskType.TEMPLATE) {
    //   $ngRedux.dispatch(createTemplateTaskRequestModal.actions.showModal({
    //     projectId,
    //     orgId,
    //     model,
    //   }));
    // }
  }

  function goToMilestonesCreate(milestone) {
    const rootState = $ngRedux.getState();
    const project = getProject(rootState);
    const organization = getOrganization(rootState);

    if (milestone) {
      $ngRedux.dispatch(updateMilestoneRequestModal.actions.showModal({
        model: milestone,
      }));
    } else if (project) {
      $ngRedux.dispatch(createMilestoneRequestModal.actions.showModal({
        taskType: ctrlConfig.taskType,
        projectId: getId(project),
        orgId: getId(organization),
      }));
    }
  }

  function deleteMilestone(milestone) {
    if (milestone) {
      const id = getId(milestone);
      const label = getAsString(milestone);
      const parentId = getLink(milestone, 'project').id;
      const action = getTaskListActions(ctrlConfig.taskType).deleteItem({
        id,
        collection: MILESTONE_COLLECTION,
        label,
      }, {parentId});

      return (
        milestone.assetSpecific
          ? $popup
            .countdownConfirm({
              title: 'Delete Template Milestone',
              template: `<div style="text-align: center;">Are you sure you want to delete<br/>
${label}<br/>
This will delete the milestone and all of it's tasks from all assets in the project.</div>`,
            })
          : $popup
            .countdownConfirm({
              title: 'Delete Milestone',
              template: `<div style="text-align: center;">Are you sure you want to delete<br/>
${label}<br/>
This will delete all associated tasks.</div>`,
            })
      )
        .then(result => !result
          ? void 0
          : $ngRedux.dispatch(action)
        );
    }
  }

  let openTaskImportCalled = false;

  function openTaskImport() {
    if (openTaskImportCalled) return;
    openTaskImportCalled = true;
    const rootState = $ngRedux.getState();
    const project = getProject(rootState);
    const assetProject = getAssetProject(rootState);

    let projectId;
    let type;
    if (ctrlConfig.taskType === TaskType.ASSET) {
      projectId = getId(assetProject);
      type = null;
    } else {
      projectId = getId(project);
      type = ctrlConfig.taskType === TaskType.PROJECT ? 'project' : 'asset';
    }

    if (projectId) {
      return $modal.show({
        templateUrl: 'projects/project-import.html',
        controller: 'ProjectImportController',
        animation: 'slide-in-up',
        locals: {
          project: projectId,
          assetLevel: ctrlConfig.taskType === TaskType.ASSET,
          type: type,
        },
      }).then(__openTaskImportFinally, __openTaskImportFinally);
    } else {
      openTaskImportCalled = false;
      // TODO: shouldn't happen. recover??
      $log.debug('TasksListController.openTaskImport: No project detected. Aborting.');
    }
  }

  function __openTaskImportFinally(it) {
    openTaskImportCalled = false;
    return it;
  }

  let openTaskExportCalled = false;

  function openTaskExport() {
    if (openTaskExportCalled) return;
    openTaskExportCalled = true;

    const rootState = $ngRedux.getState();
    const project = getProject(rootState);
    const asset = getAsset(rootState);
    const assetProject = getAssetProject(rootState);

    let projectId;
    let projectName;
    let type;
    if (ctrlConfig.taskType === TaskType.ASSET) {
      projectId = getId(assetProject);
      projectName = asset && project ? project.name + '-' + asset.name : 'export';
      type = null;
    } else {
      projectId = getId(project);
      projectName = project ? project.name : 'export';
      type = ctrlConfig.taskType === TaskType.PROJECT ? 'project' : 'asset';
    }

    if (projectId) {
      return $modal.show({
        templateUrl: 'projects/project-export.html',
        controller: 'ProjectExportController',
        animation: 'slide-in-up',
        locals: {
          project: projectId,
          projectName: projectName,
          assetLevel: ctrlConfig.taskType === TaskType.ASSET,
          type: type,
        },
      }).then(__openTaskExportFinally, __openTaskExportFinally);
    } else {
      openTaskExportCalled = false;
      // TODO: shouldn't happen. recover??
      $log.debug('TasksListController.openTaskExport: No project detected. Aborting.');
    }
  }

  function __openTaskExportFinally(it) {
    openTaskExportCalled = false;
    return it;
  }

  function removeAssetFromProject() {
    const rootState = $ngRedux.getState();
    const asset = getAsset(rootState);
    const assetProject = getAssetProject(rootState);

    if (assetProject) {
      const label = asset ? toStringStatic(asset) : 'this asset';
      const id = getId(assetProject);
      const action = deleteAssetProjectRequest.actions.sendRequest({
        label,
        id,
      });
      // TODO(i18n): translate confirmation
      // TODO(i18n): translate task delete confirmation
      return $popup
        .textInputConfirm({
          title: 'Remove Asset',
          body: `Are you sure you want to remove<br/>${label}<br/>Please enter<br/>REMOVE<br/>and press OK to continue`,
          confirmText: 'REMOVE',
        })
        .then(result => !result
          ? void 0
          : $ngRedux.dispatch(action)
        );
    }
  }

  function editProject() {
    const rootState = $ngRedux.getState();
    const project = getProjectModel(rootState);
    $ngRedux.dispatch(updateProjectRequestModal.actions.showModal({model: project}));
  }

  function deleteProject() {
    const rootState = $ngRedux.getState();
    const project = getProject(rootState);

    if (project) {
      const label = project.name;
      const id = getId(project);
      const action = deleteProjectRequest.actions.sendRequest({
        label,
        id,
      });
      // TODO(i18n): translate confirmation
      // TODO(i18n): translate task delete confirmation
      return $popup
        .textInputConfirm({
          title: 'Delete Project',
          /* eslint-disable-next-line max-len */
          body: `Are you sure you want to delete<br/>${label}<br/>Please enter<br/>DELETE<br/>and press OK to continue`,
          confirmText: 'DELETE',
        })
        .then(result => !result
          ? void 0
          : $ngRedux.dispatch(action)
        );
    }
  }

  // TODO(i18n): translate task delete confirmation
  function deleteTask(task) {
    if (task) {
      const collection = getCollection(task);
      const id = getId(task);
      const label = getAsString(task);
      const parentId = collection === TASK_COLLECTION ? getLink(task, 'project').id : getLink(task, 'assetProject').id;
      const action = getTaskListActions(ctrlConfig.taskType).deleteItem({
        id,
        collection,
        label,
      }, {parentId});

      return (
        collection === TASK_COLLECTION && task.assetSpecific
          ? $popup
            .countdownConfirm({
              title: 'Delete Template Task',
              template: `<div style="text-align: center;">Are you sure you want to delete<br/>
${label}<br/>
This will delete the task from all assets in the project.</div>`,
            })
          : $popup
            .confirm({
              title: 'Delete Task',
              template: `<div style="text-align: center;">Are you sure you want to delete<br/>${label}</div>`,
            })
      )
        .then(result => !result
          ? void 0
          : $ngRedux.dispatch(action)
        );
    }
  }
}



// WEBPACK FOOTER //
// ./src/js/tasks/controllers/TasksListController.js